export default (get, productType) => {
  return Object.keys(get().compatibilitySegments).filter(
    (key) => get().compatibilitySegments[key].find((item) => item.productType === productType));
};
